import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import type { Demographic } from 'types/Demographic'
import DemographicAPI from 'api/ApiActions/Demographic/Demographic'
import type { RootState } from 'redux/store/RootReducer'
import type { AppDispatch } from 'redux/store'

interface InitialEthnicityDataType {
  data: Demographic[]
  fetching: boolean
  doneFetching: boolean
  fetchError: string
}

const initialState: InitialEthnicityDataType = {
  data: [],
  fetching: false,
  doneFetching: false,
  fetchError: '',
}

export const fetchEthnicity: any = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch
    state: RootState
  }
>('ethnicity/fetchEthnicity', async (params = {}, { rejectWithValue }) => {
  params = {
    ...params,
    filters: {
      subtype: 'ethnicity',
      deleted: false,
    },
  }

  try {
    const response = await DemographicAPI.getDemographics(params)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const ethnicity = createSlice({
  name: 'ethnicity',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchEthnicity.pending.toString()]: (state) => {
      state.fetching = true
    },
    [fetchEthnicity.fulfilled.toString()]: (state, action) => {
      state.data = action.payload
      state.fetching = false
      state.doneFetching = true
    },
    [fetchEthnicity.rejected.toString()]: (state, action) => {
      state.fetchError = action.payload
      state.fetching = false
      state.doneFetching = false
    },
  },
})

export default ethnicity.reducer
